import { atom } from 'jotai';

import type { LabsStatus } from './prototype-assignment';
import { PROTOTYPE_FLAG_DEFAULT, PrototypeFlag } from './prototype-flag';

export interface LabsAssignment {
  status: LabsStatus;
  prototype: PrototypeFlag;
}

/**
 * Published by useFrontendBranchAssignment (mounted once in AppLayout) for the Labs icon to render.
 */
export const labsAssignmentAtom = atom<LabsAssignment>({
  status: 'none',
  prototype: PROTOTYPE_FLAG_DEFAULT,
});
labsAssignmentAtom.debugLabel = 'labsAssignment';

/**
 * Whether the Labs dialog is open. The dialog is mounted once in AppLayout, outside the profile
 * menu, so it survives the menu closing.
 */
export const labsDialogOpenAtom = atom(false);
labsDialogOpenAtom.debugLabel = 'labsDialogOpen';
